import { render, staticRenderFns } from "./DashboardChooserControls.vue?vue&type=template&id=51dd82a2&scoped=true"
import script from "./DashboardChooserControls.vue?vue&type=script&lang=js"
export * from "./DashboardChooserControls.vue?vue&type=script&lang=js"
import style0 from "./DashboardChooserControls.vue?vue&type=style&index=0&id=51dd82a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dd82a2",
  null
  
)

export default component.exports